module.exports = __webpack_public_path__ + "img/logo.8da5d425.png";